import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const navLinks = [
  { label: "Home", href: "#hero" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Overstock", href: "#overstock" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-16">
        {/* Logo */}
        <a href="#hero" onClick={() => handleNavClick("#hero")} className="flex items-center gap-2 cursor-pointer">
          <div className="w-8 h-8 rounded-lg bg-[#C9A227] flex items-center justify-center">
            <i className="ri-links-line text-white text-base"></i>
          </div>
          <span className={`font-bold text-lg tracking-tight ${scrolled ? "text-[#222831]" : "text-white"}`}>
            LTF Sourcing
          </span>
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-7">
          {navLinks.map((link) => (
            <li key={link.label}>
              <button
                onClick={() => handleNavClick(link.href)}
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  scrolled
                    ? "text-[#222831] hover:text-[#C9A227]"
                    : "text-white/90 hover:text-white"
                }`}
              >
                {link.label}
              </button>
            </li>
          ))}
          <li>
            <button
              onClick={() => navigate("/blog")}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "text-[#C9A227] hover:text-[#b08f1e]"
                  : "text-[#C9A227] hover:text-white"
              }`}
            >
              Blog
            </button>
          </li>
        </ul>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => handleNavClick("#contact")}
            className="text-sm font-semibold px-5 py-2 rounded-full bg-[#C9A227] text-white hover:bg-[#b08f1e] transition-colors cursor-pointer whitespace-nowrap"
          >
            Get a Quote
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${scrolled ? "text-[#222831]" : "text-white"}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-xl`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#D9E2EC] px-6 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNavClick(link.href)}
              className="text-sm font-medium text-[#222831] hover:text-[#C9A227] text-left cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => { setMenuOpen(false); navigate("/blog"); }}
            className="text-sm font-semibold text-[#C9A227] text-left cursor-pointer whitespace-nowrap"
          >
            Blog
          </button>
          <button
            onClick={() => handleNavClick("#contact")}
            className="mt-2 text-sm font-semibold px-5 py-2 rounded-full bg-[#C9A227] text-white text-center cursor-pointer whitespace-nowrap"
          >
            Get a Quote
          </button>
        </div>
      )}
    </nav>
  );
}